var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDlticn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9094 13.0125H4.08437C3.5459 13.0125 3.10938 12.5759 3.10938 12.0375V3.26245H11.8844V12.0375C11.8844 12.5759 11.4479 13.0125 10.9094 13.0125Z",
    stroke: "#EF3826",
    strokeWidth: 0.975,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03594 10.0875V6.1875",
    stroke: "#EF3826",
    strokeWidth: 0.975,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95977 10.0875V6.1875",
    stroke: "#EF3826",
    strokeWidth: 0.975,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16016 3.2625H13.8352",
    stroke: "#EF3826",
    strokeWidth: 0.975,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.96055 1.3125H6.03555C5.49707 1.3125 5.06055 1.74902 5.06055 2.2875V3.2625H9.93555V2.2875C9.93555 1.74902 9.49902 1.3125 8.96055 1.3125Z",
    stroke: "#EF3826",
    strokeWidth: 0.975,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlticn);
export default __webpack_public_path__ + "static/media/dlticn.155702042288ff250d97e24d728bd0a1.svg";
export { ForwardRef as ReactComponent };